module.exports = __webpack_public_path__ + "img/test.be3ca898.png";